/**
 * @author: Yaochao
 * @date: 2021-07-05 17:04
 * @description：表格操作按钮样式
 */

import React from "react";

const ZkOptBtns = props => {
    return <ul className='tableOptBtns' style={{...props.style}}>
        {
            React.Children.map(props.children, (child, index) => {
                if ((typeof item == 'string') && item.length == 0) {

                } else {
                    return <li className='btnWraper' key={index}>{child}</li>
                }
            })
        }
    </ul>
};

export default ZkOptBtns